<template>
    <div>

        <div>
            <div id="hello-hello">
                <p style="display:inline;float: left;line-height: 22px;">
                    <b>模具列表</b>
                </p>

                <span style="display:inline-block;height: 40px;">
                    <i class="el-icon-search"><b>-</b></i>
                    <el-select v-model="orderSearchValue" filterable remote reserve-keyword placeholder="请输入关键字"
                        :remote-method="searchOrder" :loading="loading" @change="selectOrder">
                        <el-option v-for="item in queryOrderList" :key="item.value" :label="item.moldCode" :value="item">
                        </el-option>
                    </el-select>
                </span>

                <span>-生产状态</span>
                <p style="display:inline-block;line-height: 40px;margin:5px 0">
                    <el-radio-group v-model="statusSearch" @input="searchByStatus">
                        <el-radio-button label="0">待产</el-radio-button>
                        <el-radio-button label="1">生产中</el-radio-button>
                        <el-radio-button label="2">暂停</el-radio-button>
                        <el-radio-button label="3">完成</el-radio-button>
                        <el-radio-button label="-1">全部</el-radio-button>
                    </el-radio-group>
                </p>
            </div>

            <el-table :data="showOrderList" style="width: 100%" @select="orderSelectClick" @row-click="orderRowClick"
                ref="moldTable">
                <el-table-column type="selection" width="45" label-class-name="DisabledSelection">
                </el-table-column>

                <el-table-column prop="orderCode" label="订单编号" min-width="13%">
                </el-table-column>
                <el-table-column prop="orderCount" label="订单数量" min-width="8%" align="center">
                </el-table-column>
                <el-table-column prop="customer" label="客户" min-width="9%">
                </el-table-column>
                <el-table-column prop="productName" label="产品名称" min-width="15%">
                </el-table-column>
                <el-table-column prop="moldCode" label="模具编号" min-width="15%">
                </el-table-column>
                <el-table-column prop="deliveryTime" label="交货日期" min-width="10%">
                </el-table-column>
                <el-table-column prop="status" label="状态" min-width="6%">
                </el-table-column>
                <el-table-column prop="remark" label="备注" min-width="24%">
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div>
                <el-pagination background :page-size="pageNum" :page-count="pageCount" layout="prev, pager, next"
                    :total="total" @current-change="pageClick" hide-on-single-page>
                </el-pagination>
            </div>
        </div>

        <div>
            <p>
                <el-slider v-model="displayScale" :show-tooltip="false" @change="changeScale" :min="16" :max="71">
                </el-slider>
            </p>

            <div :style="bomDivStyle">
                <div id="hello-hello">
                    <p style="display:inline;float: left;line-height: 22px;">
                        <b>BOM列表</b>
                    </p>

                    <p style="display:inline-block;line-height: 40px;margin:5px 0">
                        <el-radio-group v-model="bigTypeSearch" @input="searchByBigType">
                            <el-radio-button label="0">产品设计</el-radio-button>
                            <el-radio-button label="1">模具设计</el-radio-button>
                            <el-radio-button label="2">模芯</el-radio-button>
                            <el-radio-button label="3">模架</el-radio-button>
                            <el-radio-button label="-1">全部</el-radio-button>
                        </el-radio-group>
                    </p>
                </div>

                <el-table :data="bomList" style="width: 100%" @select="bomSelectClick" @row-click="bomRowClick"
                    ref="bomTable" highlight-current-row>
                    <el-table-column type="index" width="40">
                    </el-table-column>
                    <el-table-column type="selection" width="45" label-class-name="DisabledSelection">
                    </el-table-column>

                    <el-table-column prop="sparePartCode" label="配件编号" min-width="25%">
                    </el-table-column>
                    <el-table-column prop="sparePartName" label="配件名称" min-width="25%">
                    </el-table-column>
                    <el-table-column prop="status" label="状态" width="70">
                    </el-table-column>
                    <el-table-column prop="createdTime" label="创建时间" width="110">
                    </el-table-column>
                    <el-table-column prop="remark" label="备注" min-width="50%">
                    </el-table-column>
                </el-table>
            </div>

            <div :style="processDivStyle">
                <div id="hello-hello">
                    <p style="display:inline;float: left;line-height: 22px;"><b>工艺列表</b></p>
                    <p style="display:inline;float: right;line-height: 40px;margin: 5px 0;">
                        <el-button round type="success" @click="openDialog">新增工艺</el-button>
                    </p>
                </div>

                <el-table :data="processList" style="width: 100%" tooltip-effect="dark">
                    <el-table-column type="index" width="20" fixed>
                    </el-table-column>

                    <el-table-column prop="processName" label="工艺名称" min-width="42%" fixed>
                    </el-table-column>

                    <!-- <el-table-column prop="takeTime" label="耗时" width="100">
                        <template slot="header">
                            <el-tooltip class="item" effect="dark" placement="top" content="当前工艺花费时间（单位小时）">
                                <span>耗时</span>
                                <i class="el-icon-question"></i>
                            </el-tooltip>
                        </template>
                    </el-table-column> -->

                    <el-table-column prop="statusDes" label="状态" width="70">
                        <template slot="header">
                            <el-tooltip class="item" effect="light" placement="top" content="状态：待上机、排队中、已上机、暂停、完成">
                                <span>状态</span>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column prop="createdTime" label="创建时间" width="110">
                    </el-table-column>
                    <el-table-column prop="remark" label="备注" min-width="58%">
                    </el-table-column>

                    <el-table-column fixed="right" label="操作" width="150">
                        <template slot-scope="scope">
                            <el-button @click="handleClick(scope.row)" type="primary" round size="small"
                                v-if="scope.row.editable">
                                {{ scope.row.editable === true ? '编辑' : '' }}
                            </el-button>
                            <el-button @click="deleteClick(scope.row)" type="warning" round size="small"
                                v-if="scope.row.editable">
                                {{ scope.row.editable === true ? '删除' : '' }}
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <el-dialog title="工艺详情" :visible.sync="dialogFormVisible" width="60%">
                    <el-form :inline="true" :model="form">

                        <el-form-item label="配件编号" required :label-width="formLabelWidth">
                            <el-input v-model="form.sparePartCode" autocomplete="off" style="width:220px"
                                disabled></el-input>
                        </el-form-item>
                        <!-- <div style="width:350px;display: inline-block;"></div> -->

                        <el-form-item label="工艺名称" required :label-width="formLabelWidth">
                            <el-input v-model="form.processName" autocomplete="off" style="width:220px"
                                :disabled="processNameDisable"></el-input>
                        </el-form-item>

                        <!-- <el-form-item label="耗时(小时)" :label-width="formLabelWidth">
                            <el-input-number v-model="form.takeTime" :precision="1" :step="0.5" :min="0.1"
                                style="width:220px"></el-input-number>
                        </el-form-item> -->

                        <el-form-item label="状态" :label-width="formLabelWidth" v-if="statusVisible">
                            <el-radio-group v-model="form.status" style="width:570px">
                                <el-radio :label="0">待上机</el-radio>
                                <el-radio :label="1">排队中</el-radio>
                                <el-radio :label="2">已上机</el-radio>
                                <el-radio :label="3">暂停</el-radio>
                                <el-radio :label="4">完成</el-radio>
                            </el-radio-group>
                        </el-form-item>

                        <el-form-item label="备注" :label-width="formLabelWidth">
                            <el-input v-model="form.remark" autocomplete="off" type="textarea"
                                style="width:570px"></el-input>
                        </el-form-item>
                    </el-form>

                    <div slot="footer" class="dialog-footer">
                        <el-button @click="dialogFormVisible = false">取 消</el-button>
                        <el-button type="primary" @click="addProcess" v-show="saveButtonVisible">保 存</el-button>
                    </div>
                </el-dialog>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Process",
    data() {
        return {
            gc: 0,
            token: this.getToken(),
            userId: this.getUserId(),
            companyId: this.getCompanyId(),
            statusSearch: 0,
            orderSearchValue: '',
            queryOrderList: [],
            showOrderList: [],
            dialogFormVisible: false,
            saveButtonVisible: true,
            form: {
                id: '',
                moldCode: '',
                sparePartCode: '',
                processName: '',
                //takeTime: '',
                processType: 0,
                status: 0,
                maker: '',
                remark: ''
            },
            formLabelWidth: '120px',
            statusVisible: false,
            bomList: [],
            processList: [],
            displayScale: 50,
            bomDivStyle: {
                display: 'inline-block',
                // width: '600px',
                width: '50%',
                float: 'left'
            },
            processDivStyle: {
                display: 'inline-block',
                // width: '500px',
                width: '45%',
                float: 'right'
            },
            processNameDisable: false,
            loading: false,
            bigTypeSearch: 0,
            pageIndex: 0,
            pageNum: 3,
            total: 0,
            pageCount: 0
        }
    },
    methods: {
        searchByStatus(val) {
            this.getAllOrder(val)
            // this.queryOrder(query)

            this.bomList = []

        },
        searchOrder(query) {
            if (query !== '') {
                this.loading = true;
                setTimeout(() => {
                    this.loading = false;
                    this.queryOrder(query)
                }, 200);
            } else {
                this.queryOrderList = [];
            }
        },
        orderSelectClick(row){
            this.$refs.moldTable.clearSelection()
            this.$refs.moldTable.toggleRowSelection(row)

            this.form.moldCode = row.moldCode
            
            this.getAllBOM(this.bigTypeSearch)
            this.form.sparePartCode = ''
            this.processList = []
        },
        orderRowClick(row){
            this.orderSelectClick(row)
        },
        getAllOrder(val) {
            const formData = new FormData()
            formData.append('status', val)
            formData.append('assemblyProgress', 0)
            formData.append('companyId', this.companyId)
            formData.append('pageIndex', this.pageIndex)
            formData.append('pageNum', this.pageNum)

            this.$axios({
                method: "post",
                url: "/shiro/mold/order/getAll",
                data: formData,
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                this.bomList=[]
                this.showOrderList = data.data
                this.total = this.showOrderList[0].total
                // this.pageCount = this.total % this.pageNum == 0 ? this.total % this.pageNum : this.total % this.pageNum + 1
                for (let i in this.showOrderList) {

                    this.showOrderList[i].deliveryTime = this.$moment(this.showOrderList[i].deliveryTime).format("YYYY-MM-DD")

                    if (this.showOrderList[i].status == 0) {
                        this.showOrderList[i].status = '待产'
                    } else if (this.showOrderList[i].status == 1) {
                        this.showOrderList[i].status = '生产中'
                    } else if (this.showOrderList[i].status == 2) {
                        this.showOrderList[i].status = '暂停'
                    } else {
                        this.showOrderList[i].status = '完成'
                    }
                }
            })
        },
        selectOrder(value) {
            // console.log('selectOrder')
            // console.log(value)
            this.orderSearchValue = value.moldCode
            this.showOrderList = []
            this.total = 1
            this.showOrderList.push(value)

            //this.$refs.moldTable.toggleRowSelection(this.$refs.moldTable.tableData[0])

            this.form.moldCode = value.moldCode

            this.bomList=[]
            // this.getAllBOM(this.bigTypeSearch)
            this.form.sparePartCode = ''
            this.processList = []
            //this.gc=2
            //this.form.sparePartCode = this.$refs.bomTable.tableData[0].sparePartCode
            //this.getAllProcess()
        },
        bomSelectClick(selection, row) {
            this.$refs.bomTable.clearSelection()
            this.$refs.bomTable.toggleRowSelection(row)
            this.form.sparePartCode = row.sparePartCode
            this.processList = []
            this.getAllProcess()
        },
        bomRowClick(row) {
            //console.log(row)
            this.$refs.bomTable.clearSelection()
            this.$refs.bomTable.toggleRowSelection(row, true)
            this.form.sparePartCode = row.sparePartCode
            this.processList = []
            this.getAllProcess()
        },
        changeScale(val) {
            //console.log('cscs')
            //console.log(val)
            var bomWidth = val
            // this.bomDivStyle.width = bomWidth + 'px'
            // this.processDivStyle.width = 500 + (600 - bomWidth) + 'px'
            this.bomDivStyle.width = bomWidth + '%'
            this.processDivStyle.width = (100 - 5 - bomWidth) + '%'
        },
        searchByBigType(val) {
            this.form.sparePartCode = ''
            this.bomList = []
            this.processList = []
            this.bigTypeSearch = parseInt(val)

            this.getAllBOM(this.bigTypeSearch)
        },
        handleClick(row) {
            //console.log(row);
            this.form.id = row.id

            this.form.moldCode = row.moldCode

            this.form.sparePartCode = row.sparePartCode
            this.form.processName = row.processName
            this.form.status = row.status
            //console.log(this.form.status)

            this.form.remark = row.remark

            this.processNameDisable = true
            this.statusVisible = true
            this.dialogFormVisible = true
        },
        openDialog() {

            if (this.form.sparePartCode == '') {
                this.$message({
                    type: 'info',
                    message: '请先选择BOM'
                })
                return
            }

            this.form.id = ''
            //this.form.sparePartCode = ''
            this.form.processName = ''
            //this.form.takeTime = ''
            this.form.processType = 0
            this.form.status = 0
            this.form.maker = this.userId
            this.form.remark = ''

            this.processNameDisable = false
            this.statusVisible = false
            this.dialogFormVisible = true
        },
        deleteClick(row) {
            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.removeProcess(row)
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        addProcess() {
            this.$axios({
                method: "post",
                url: "/shiro/process/add",
                data: {
                    id: this.form.id,
                    moldCode: this.form.moldCode,
                    sparePartCode: this.form.sparePartCode,
                    processName: this.form.processName,
                    // takeTime: this.form.takeTime,
                    processType: this.form.processType,
                    status: this.form.status,
                    maker: this.form.maker,
                    remark: this.form.remark,

                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status != 200) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })
                    return
                }

                if (data.status == 200) {
                    this.$message({
                        type: 'success',
                        message: data.msg
                    })
                }

                this.dialogFormVisible = false

                //console.log('addProcess')
                //this.gc=999

                this.getAllBOM(this.bigTypeSearch)
                
                this.getAllProcess()
            })
        },
        getAllProcess() {
            this.$axios({
                method: "post",
                url: "/shiro/process/getAll",
                data: {
                    moldCode: this.form.moldCode,
                    bomBigType: this.bigTypeSearch,
                    sparePartCode: this.form.sparePartCode,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" });
                }

                this.processList = data.data
                for (let i in this.processList) {

                    this.processList[i].createdTime = this.$moment(this.processList[i].createdTime).format("YYYY-MM-DD")

                    if (this.processList[i].status == 0) {
                        this.processList[i].statusDes = '待上机'
                    } else if (this.processList[i].status == 1) {
                        this.processList[i].statusDes = '排队中'
                    } else if (this.processList[i].status == 2) {
                        this.processList[i].statusDes = '已上机'
                    } else if (this.processList[i].status == 3) {
                        this.processList[i].statusDes = '暂停'
                    } else {
                        this.processList[i].statusDes = '完成'
                    }
                }
            })
        },
        removeProcess(row) {
            this.$axios({
                method: "delete",
                url: "/shiro/process/remove",
                data: {
                    id: row.id,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {
                this.getAllProcess()
            })
        },
        queryOrder(val) {

            const formData = new FormData()
            formData.append('moldCode', val)
            // formData.append('status', val)
            formData.append('companyId', this.companyId)

            this.$axios({
                method: "post",
                url: "/shiro/mold/order/query",
                data: formData,
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" });
                }

                if (data.status === 202) {
                    this.$notify({
                        title: '重要提示',
                        message: data.msg,
                        duration: 0
                    });
                    return
                }

                this.queryOrderList = data.data

                for (let i in this.queryOrderList) {

                    this.queryOrderList[i].deliveryTime = this.$moment(this.queryOrderList[i].deliveryTime).format("YYYY-MM-DD")

                    if (this.queryOrderList[i].status == 0) {
                        this.queryOrderList[i].status = '待产'
                    } else if (this.queryOrderList[i].status == 1) {
                        this.queryOrderList[i].status = '生产中'
                    } else if (this.queryOrderList[i].status == 2) {
                        this.queryOrderList[i].status = '暂停'
                    } else {
                        this.queryOrderList[i].status = '完成'
                    }
                }

            })
        },
        getAllBOM(val) {
            this.$axios({
                method: "post",
                url: "/shiro/mold/bom/getAll",
                data: {
                    moldCode: this.form.moldCode,
                    bomBigType: val,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" });
                }

                this.bomList = data.data
                for (let i in this.bomList) {

                    this.bomList[i].createdTime = this.$moment(this.bomList[i].createdTime).format("YYYY-MM-DD")

                    if (this.bomList[i].status == 0) {
                        this.bomList[i].status = '待加工'
                    } else if (this.bomList[i].status == 1) {
                        this.bomList[i].status = '加工中'
                    } else if (this.bomList[i].status == 2) {
                        this.bomList[i].status = '暂停'
                    } else {
                        this.bomList[i].status = '完成'
                    }
                }

                //console.log(this.$refs.bomTable)
                //console.log(this.$refs.bomTable.tableData[0])
                //this.bomRowClick(this.$refs.bomTable.tableData[0])
                //this.$refs.bomTable.toggleRowSelection(this.$refs.bomTable.tableData[0])
            })
        },
        pageClick(currentPage) {

            this.pageIndex = (currentPage - 1) * this.pageNum
            this.getAllOrder(this.statusSearch)
        }
    },
    mounted() {
        this.queryOrder(this.orderSearchValue)
        //console.log('mmm')
        //console.log(this.$el.$refs)
        //console.log(this.$refs.moldTable.tableData[0])
    },
    beforeUpdate() {
        //console.log('bububu')
    },
    updated() {
        // var checkBoxEle = document.getElementsByClassName("el-checkbox")
        // console.log('ududud')
        //console.log(checkBoxEle)
        // checkBoxEle[0].innerHTML = ''

        //console.log(this.gc)

        if (this.gc == 1) {
            // console.log(this.$refs.moldTable)
            if (this.$refs.moldTable.selection.length == 0) {
                this.$refs.moldTable.toggleRowSelection(this.$refs.moldTable.tableData[0])
            }

            if (this.$refs.moldTable.tableData.length > 0) {

                this.form.moldCode = this.$refs.moldTable.tableData[0].moldCode

                this.getAllBOM(this.bigTypeSearch)
            }

        }

        this.gc++
    }
}
</script>

<style>
#create_work {
    position: relative;
    right: 5px;
    width: 120px;
}

.DisabledSelection .el-checkbox__inner{
  display: none;
  position: relative;
}
</style>